import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import BuscarProyecto from "./components/BuscarProyecto/BuscarProyecto";
import ActualizarProyecto from "./components/ActualizarProyecto/ActualizarProyecto";
import Organizaciones from "./components/Organizaciones/Organizaciones";
import AccesoRestringido from "./components/AccesoRestringido/AccesoRestringido";
import FileManager from "./components/DetalleProyecto/FileManager";
import MerOrganizaciones from "./components/Organizaciones/MerOrganizaciones";
import Poa from "./components/Poa/Poa";
import LogosFooter from "./components/LogosHeader/LogosFooter";
import NavBodecom from "./components/header/navBodecom";
import LoginBodecom from "./components/Login/loginBodecom";
import PrivateRoute from "./components/Login/PrivateRoute";
import ReporteInformes from "./components/Informes/InsumoReportes";
import MapaInicio from "./components/mapas/mapaInicio";
import Inicio from "./components/Inicio/Inicio";
import ProyectosSostenibilidad from "./components/Sostenibilidad/ProyectosSostenibilidad";
import RenderizarComponenteParticipantes from "./components/Participants/renderizarComponenteParticipantes";
import Bodegas from "./components/Financiero/Bodegas/Bodegas";
import Productos from "./components/Financiero/Productos/ProductosSostenibilidad";

//Planes de Compra
import PlanesCompras from "./components/Financiero/PlanesCompras/PlanesCompras";
import PlanesCompraSostenibilidad from "./components/Financiero/PlanesCompras/PlanesComprasSostenibilidad";
//Poa Sostenibilidad
import PoaProyectosSostenibilidad from "./components/Sostenibilidad/PoaProyectosSostenibilidad";
import DynamicTree from "./components/Sostenibilidad/DetallePOASostenibilidad";
import PoaSostenibilidad from "./components/Poa/PoaSostenibilidad";
import InformeVisitasTecnicas from "./components/Visitas/informe/informeVisitasTecnicas";
import ParticipantesSostenibilidad from "./components/Sostenibilidad/participantes/ParticipantesSostenibilidad";
import InformeNovedades from "./components/Visitas/informe/informeNovedades";
import TablaVisitaTecnicasostenibilidad from "./components/Sostenibilidad/VisitaTecnicaSostenibilidad/TablaVisitaTecnicaSostenibilidad";
import InformeSeguimientoMonitoreo from "./components/Visitas/informe/InformeSeguimientoMonitereo";
import InformeAutorizacionImagen from "./components/Visitas/informe/informeAutorizacionImagen";
import TablaHistorialVisitas from "./components/Visitas/HistorialVisitasPatti/TablaHistorialVisitas";
import AutogenerarPdf from "./components/Visitas/autogenerarPdf";
import InformeVisitasTecnicasSostenibilidad from "./components/Sostenibilidad/informes/informeVisitaTecnicaSostenibilidad";
import PoaPlanOperativo from "./components/Po/PoaPlanOperativo";

//Geovisor
import FormatoAceptacionPlanCompra from "./components/Financiero/PlanesCompras/FormatoAceptacionCompra/FormatoAceptacionCompras";
import FileManagerPrueba from "./components/Visitas/FileManager";
import AdminPanel from "./pages/AdminPanel";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/auth/store";
import ForceLogoutModal from "./components/Login/ForceLogoutModal";
import GeovisorPaati from "./components/Geovisor/Geovisor_paati";

//Entregas
//Ordenes de compra
import OrdenesServicios from "./components/Entregas/OrdenesServicios";
import ProveedoresPO from "./components/Entregas/ProveedoresPO";
import StockBodegas from "./components/Entregas/StockBodegas";
import EntregasPaati from "./components/Entregas/EntregasPaati";
import EspigaDashboard from "./components/Espiga/InformeMonotoreoEspiga";
import EntregasSostenibilidad from "./components/Entregas/EntregasSostenibilidad";
import InformeIngresoPO from "./components/Entregas/informes/informeIngresoPO";
import TablaSalidas from "./components/Entregas/TablaSalidaBodega";
import InformeEntregas from "./components/Entregas/informes/informeEntregas";
import GeovisorArn from "./components/Geovisor/Geovisor_arn";
import InformePlanComprasGeneral from "./components/Entregas/informes/InformePlanComprasGeneral";
import InformeOrdenesCompra from "./components/Entregas/informes/informeOrdenComprasGeneral";
import InformeGeneralProyecto from "./components/Entregas/informes/informeGeneralPorProyecto";
import InformePlanesCompras from "./components/Financiero/PlanesCompras/InformePlanesCompras";

import { useSelector } from "react-redux";
import InformeEntregasPO from "./components/Entregas/informes/informeEntregasByProductoPO";
import GeovisorSostenibilidad from "./components/Geovisor/Geovisor_sostenibilidad.jsx";

const AppContent = () => {
  const location = useLocation();
  const showNavAndFooter = !["/", "/acceso-restringido"].includes(
    location.pathname
  );

  const { isAuthenticated, is_group5, user } = useSelector((s) => s.auth);
  const isGroup5 = Boolean(user?.is_group5 ?? is_group5);

  return (
    <>
      {showNavAndFooter && <NavBodecom />}
      <ForceLogoutModal />
      <Routes>
        {/* Raíz: si no autenticado => Login; si autenticado => decide por is_group5 */}
        <Route
          path="/"
          element={
            !isAuthenticated ? (
              <LoginBodecom />
            ) : isGroup5 ? (
              <Navigate to="/planOperativo" replace />
            ) : (
              <Navigate to="/inicio" replace />
            )
          }
        />

        {/* /inicio: si es grupo 5, no debe ver inicio */}
        <Route
          path="/inicio"
          element={
            isGroup5 ? (
              <Navigate to="/planOperativo" replace />
            ) : (
              <PrivateRoute element={<Inicio />} />
            )
          }
        />

        <Route
          path="/mapas"
          element={<PrivateRoute element={<MapaInicio />} />}
        />
        <Route
          path="/reportes"
          element={<PrivateRoute element={<ReporteInformes />} />}
        />
        <Route
          path="/buscar-proyecto"
          element={<PrivateRoute element={<BuscarProyecto />} />}
        />
        <Route
          path="/actualizar-proyecto"
          element={<PrivateRoute element={<ActualizarProyecto />} />}
        />
        <Route
          path="/organizaciones/:oid_proyecto_busqueda?"
          element={<PrivateRoute element={<Organizaciones />} />}
        />
        <Route
          path="/mer/:oid_proyecto_busqueda?"
          element={<PrivateRoute element={<MerOrganizaciones />} />}
        />
        <Route
          path="/file-manager"
          element={<PrivateRoute element={<FileManager />} />}
        />
        <Route path="/poa" element={<PrivateRoute element={<Poa />} />} />
        <Route
          path="/sostenibilidad"
          element={<PrivateRoute element={<ProyectosSostenibilidad />} />}
        />
        <Route
          path="/DocumentosFAO"
          element={<Navigate to="/acceso-restringido" />}
        />
        <Route
          path="/Proyectos166"
          element={<Navigate to="/acceso-restringido" />}
        />
        <Route
          path="/DocumentosOrganizaciones"
          element={<Navigate to="/acceso-restringido" />}
        />
        <Route path="/acceso-restringido" element={<AccesoRestringido />} />

        {/*PATTI*/}
        <Route
          path="/participantes"
          element={
            <PrivateRoute element={<RenderizarComponenteParticipantes />} />
          }
        />
        <Route
          path="/productos"
          element={<PrivateRoute element={<Productos />} />}
        />
        <Route
          path="/planesdecompras"
          element={<PrivateRoute element={<PlanesCompras />} />}
        />
        <Route
          path="/informeSeguimientoMonitoreo"
          element={<InformeSeguimientoMonitoreo />}
        />
        <Route
          path="/informe-visitasTecnicas"
          element={<PrivateRoute element={<InformeVisitasTecnicas />} />}
        />
        <Route
          path="/informe-novedades"
          element={<PrivateRoute element={<InformeNovedades />} />}
        />
        <Route
          path="/informe-autorizacionImagen"
          element={<PrivateRoute element={<InformeAutorizacionImagen />} />}
        />
        <Route
          path="/historial-visitas-paati"
          element={<PrivateRoute element={<TablaHistorialVisitas />} />}
        />
        <Route
          path="/autogenerarPDF"
          element={<PrivateRoute element={<AutogenerarPdf />} />}
        />

        <Route
          path="/informePlanComprasPaati"
          element={<PrivateRoute element={<InformePlanesCompras />} />}
        />
        {/*Financiero*/}
        <Route
          path="/bodegas"
          element={<PrivateRoute element={<Bodegas />} />}
        />
        {/*POA Sostenibilidad*/}

        <Route
          path="/planesdecomprasostenibilidad"
          element={<PrivateRoute element={<PlanesCompraSostenibilidad />} />}
        />
        <Route
          path="/poas"
          element={<PrivateRoute element={<PoaProyectosSostenibilidad />} />}
        />
        <Route path="/dynamic-tree/:codigoInterno" element={<DynamicTree />} />
        <Route
          path="/poasostenibilidad/:codigoInterno?"
          element={<PrivateRoute element={<PoaSostenibilidad />} />}
        />
        <Route
          path="/visitas-tecnicas-sostenibilidad"
          element={
            <PrivateRoute element={<TablaVisitaTecnicasostenibilidad />} />
          }
        />
        <Route
          path="/participantes-sostenibilidad"
          element={<PrivateRoute element={<ParticipantesSostenibilidad />} />}
        />

        <Route
          path="/informe-visitas-tecnicas-sostenibilidad"
          element={
            <PrivateRoute element={<InformeVisitasTecnicasSostenibilidad />} />
          }
        />

        <Route
          path="/mapa-paati"
          element={
            <PrivateRoute
              element={<GeovisorPaati pathInicial={"Geovisor PAATI"} />}
            />
          }
        />

        <Route
          path="/mapa-sostenibilidad"
          element={
            <PrivateRoute
              element={
                <GeovisorSostenibilidad
                  pathInicial={"Geovisor sostenibilidad"}
                />
              }
            />
          }
        />

        <Route
          path="/mapa-arn"
          element={
            <PrivateRoute
              element={<GeovisorArn pathInicial={"Geovisor ARN"} />}
            />
          }
        />




        <Route
          path="/formatoAceptacionPlanCompra"
          element={<PrivateRoute element={<FormatoAceptacionPlanCompra />} />}
        />

        {/*POA Proyectos */}
        <Route
          path="/planOperativo"
          element={<PrivateRoute element={<PoaPlanOperativo />} />}
        />
        <Route
          path="/planOperativo/:id"
          element={<PrivateRoute element={<PoaPlanOperativo />} />}
        />

        {/*Gestor de archivos */}

        <Route
          path="/gestorArchivosPAATI"
          element={
            <PrivateRoute
              element={<FileManagerPrueba pathInicial={"PAATI"} />}
            />
          }
        />

        <Route
          path="/gestorArchivosSostenibilidad"
          element={
            <PrivateRoute
              element={<FileManagerPrueba pathInicial={"DocumentosPOA"} />}
            />
          }
        />

        {/*Gestor de entregas */}

        <Route
          path="/proveedores"
          element={<PrivateRoute element={<ProveedoresPO />} />}
        />
        <Route
          path="/ordenesdeservicio"
          element={<PrivateRoute element={<OrdenesServicios />} />}
        />

        <Route
          path="/entregaspaati"
          element={<PrivateRoute element={<EntregasPaati />} />}
        />

        <Route
          path="/entregassostenibilidad"
          element={<PrivateRoute element={<EntregasSostenibilidad />} />}
        />

        <Route
          path="/stock"
          element={<PrivateRoute element={<StockBodegas />} />}
        />
        <Route
          path="/entregaspaati"
          element={<PrivateRoute element={<EntregasPaati />} />}
        />
        <Route
          path="/salidasbodega"
          element={<PrivateRoute element={<TablaSalidas />} />}
        />

        <Route
          path="/comunix"
          element={<PrivateRoute element={<AdminPanel />} />}
        />

        <Route path="*" element={<Navigate to="/acceso-restringido" />} />

        {/* Espiga */}

        <Route
          path="/informeMonitoreoEspiga"
          element={<PrivateRoute element={<EspigaDashboard />} />}
        />

        <Route
          path="/informeIngresoPO"
          element={<PrivateRoute element={<InformeIngresoPO />} />}
        />
        <Route
          path="/informeEntregas"
          element={<PrivateRoute element={<InformeEntregas />} />}
        />
        <Route
          path="/informePlanCompras"
          element={<PrivateRoute element={<InformePlanComprasGeneral />} />}
        />

        <Route
          path="/informeOrdenesCompra"
          element={<PrivateRoute element={<InformeOrdenesCompra />} />}
        />

        <Route
          path="/informeGeneralPorProyecto"
          element={<PrivateRoute element={<InformeGeneralProyecto />} />}
        />

        <Route
          path="/informeEntregasByProductoPO"
          element={<PrivateRoute element={<InformeEntregasPO />} />}
        />
      </Routes>
      {showNavAndFooter && <LogosFooter />}
    </>
  );
};
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <AppContent />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
